define([
  'jquery',
  'URI',
  'color',
  'vex',
  'articles',
  'jquery.share',
  'jquery.style',
  'jquery.styleBuffer',
  'jquery.displayrules',
  'plugins/css!../css/sumome-share-client.css',
], function($, URI, Color, vex, Articles) {

  var getCurrentUri = function() {
    var url = $('meta[property="og:url"]').eq(0).attr("content") || $('link[rel="canonical"]').eq(0).attr('href') || window.location.href.split("#")[0] || null;

    if (url) {
      var uri = URI(url);
      if (uri.is("absolute")) {
        return uri.toString();
      } else {
        console.log('Converted relative URL to => ' + uri.absoluteTo(window.location.href.split("#")[0]).toString());
        return uri.absoluteTo(window.location.href.split("#")[0]).toString();
      }
    } else {
      return url;
    }
  }

  function abbrNum(number, decPlaces) {
    var decPlaces = decPlaces || 1;

    // 2 decimal places => 100, 3 => 1000, etc
    decPlaces = Math.pow(10,decPlaces);

    // Enumerate number abbreviations
    var abbrev = [ "k", "m", "b", "t" ];

    // Go through the array backwards, so we do the largest first
    for (var i=abbrev.length-1; i>=0; i--) {

      // Convert array index to "1000", "1000000", etc
      var size = Math.pow(10,(i+1)*3);

      // If the number is bigger or equal do the abbreviation
      if (size <= number) {
         // Here, we multiply by decPlaces, round, and then divide by decPlaces.
         // This gives us nice rounding to a particular decimal place.
         number = Math.round(number*decPlaces/size)/decPlaces;

         // Handle special case where we round up to the next abbreviation
         if((number == 1000) && (i < abbrev.length - 1)) {
           number = 1;
           i++;
         }

         // Add the letter for the abbreviation
         number += abbrev[i];

         // We are done... stop
         break;
      }
    }

    return number;
  }

  $.fn.unstatic = function() {
    $(this).addClass('sumome-article');
    if ($(this).css('position') == 'static')
      $(this).css('position', 'relative');
    if ($(this).css('box-sizing') == 'content-box')
      $(this).css('box-sizing', 'border-box');
    return this;
  };

  var share = {
    settings: {},
    positionSettings: {},
    customPositions: {},
    lastScrollTop: 0,
    lastScrollUp: 0,

    initialize: function(serviceData) {
      this.api.on('9e8a4d2a-6f8c-415e-851b-bdfe4c01d5c1/service/reload', $.proxy(function() {
        this.load();
      }, this));

      this.loadFromServices(serviceData);
    },

    load: function() {
      this.settings = {
        articles: $(Articles.findAll()),
      };

      if (this.settings.articles.length > 1)
        this.settings.articles = $([]);

      var urls = [];

      this.settings.articles.each(function() {
        if (this.__url)
          urls.push(this.__url);
      });

      $.ajax({
        type: 'POST',
        dataType: 'json',
        url: this.api.properties.sumoUrl + "/apps/share/load",
        data: {
          site_id: this.api.properties.siteId,
          href: getCurrentUri(),
          urls: urls,
          geoLocation: this.api.properties.geoLocation,
          pageViews: this.api.properties.views,
          userAgent: navigator.userAgent
        },
        xhrFields: {
          withCredentials: false
        },
        crossDomain: true
      }).done($.proxy(function (data) {
        if (data && 'success' in data && data.success) {
          $.extend(this.settings, data);

          var width = Math.min(window.screen.availWidth || $(window).width(), $(window).width());

          if (this.settings.use_mobile_services && width <= this.settings.mobile_width)
            var services = this.settings.mobile_services;
          else
            var services = this.settings.services;

          // Builds our per-position settings
          var globalSettings = {
            button_padding: this.settings.button_padding,
            button_style: this.settings.button_style,
            color: this.settings.color,
            services: services,
            services_displayed: this.settings.services_displayed,
            shares_background: this.settings.shares_background,
            shares_displayed: this.settings.shares_displayed,
            size: this.settings.size,
            offset_x: 0,
            offset_y: 0,
            total_shares_displayed: this.settings.total_shares_displayed,
          };

          if ('positions' in this.settings && this.settings.positions.length) {
            this.settings.positions.forEach($.proxy(function(position) {
              if (position in this.settings.position_settings)
                this.positionSettings[position] = $.extend({}, globalSettings, this.settings.position_settings[position]);
              else
                this.positionSettings[position] = $.extend({}, globalSettings);

              switch (this.positionSettings[position].size) {
                case 'small':
                  this.positionSettings[position].sizePx = 30;
                  break;
                case 'large':
                  this.positionSettings[position].sizePx = 70;
                  break;
                default:
                  this.positionSettings[position].sizePx = 50;
                  break;
              }

              if (!this.settings.noSumoBranding && this.positionSettings[position].services.indexOf('sumome') < 0)
                this.positionSettings[position].services.push('sumome');
            }, this));
          }

          if ('custom_position_settings' in this.settings && $(this.settings.custom_position_settings).length) {
            this.settings.custom_position_settings.forEach($.proxy(function(customPosition) {
              if (!customPosition.use_settings)
                $.extend(customPosition, globalSettings);

              switch (customPosition.size) {
                case 'small':
                  customPosition.sizePx = 30;
                  break;
                case 'large':
                  customPosition.sizePx = 70;
                  break;
                default:
                  customPosition.sizePx = 50;
                  break;
              }

              this.customPositions[customPosition.position_id] = customPosition;
            }, this));
          }

          console.log('global settings: ', globalSettings);
          console.log('position settings: ', this.positionSettings);
          console.log('custom position settings: ', this.customPositions);

          this.settings.ctry = (this.api.properties.geoLocation && this.api.properties.geoLocation.ctry) ? this.api.properties.geoLocation.ctry : false;
          this.settings.views = (this.api.properties.views) ? this.api.properties.views : 1;
          this.settings.reflink = 'https://sumome.com/?src=sm-sh-' + this.api.properties.siteId + '&utm_source=sumo-powered-by&utm_medium=share&utm_campaign='+ this.api.properties.siteId;

          // Clears out positions so we can still try to render inline placements
          if (!$.isCurrentUrlAllowed(this.settings.display_rules, null, this.settings.ctry, this.settings.views)) {
            this.settings.positions = [];
          }

          this.install();
          this.fetch();
        } else {
          // do not load
        }

      }, share));
    },

    loadFromServices: function(data) {
      this.settings = { articles: $(Articles.findAll()) };
      if (this.settings.articles.length > 1) this.settings.articles = $([]);

      var urls = [];
      this.settings.articles.each(function() {
        if (this.__url) urls.push(this.__url);
      });

      if (data && 'success' in data && data.success) {
        $.extend(this.settings, data);

        var width = Math.min(window.screen.availWidth || $(window).width(), $(window).width());

        if (this.settings.use_mobile_services && width <= this.settings.mobile_width)
          var services = this.settings.mobile_services;
        else
          var services = this.settings.services;

        // Builds our per-position settings
        var globalSettings = {
          button_padding: this.settings.button_padding,
          button_style: this.settings.button_style,
          color: this.settings.color,
          services: services,
          services_displayed: this.settings.services_displayed,
          shares_background: this.settings.shares_background,
          shares_displayed: this.settings.shares_displayed,
          size: this.settings.size,
          offset_x: 0,
          offset_y: 0,
          total_shares_displayed: this.settings.total_shares_displayed,
        };

        if ('positions' in this.settings && this.settings.positions.length) {
          this.settings.positions.forEach($.proxy(function(position) {
            if (position in this.settings.position_settings)
              this.positionSettings[position] = $.extend({}, globalSettings, this.settings.position_settings[position]);
            else
              this.positionSettings[position] = $.extend({}, globalSettings);

            switch (this.positionSettings[position].size) {
              case 'small':
                this.positionSettings[position].sizePx = 30;
                break;
              case 'large':
                this.positionSettings[position].sizePx = 70;
                break;
              default:
                this.positionSettings[position].sizePx = 50;
                break;
            }

            if (!this.settings.noSumoBranding && this.positionSettings[position].services.indexOf('sumome') < 0)
              this.positionSettings[position].services.push('sumome');
          }, this));
        }

        if ('custom_position_settings' in this.settings && $(this.settings.custom_position_settings).length) {
          this.settings.custom_position_settings.forEach($.proxy(function(customPosition) {
            if (!customPosition.use_settings) $.extend(customPosition, globalSettings);

            switch (customPosition.size) {
              case 'small':
                customPosition.sizePx = 30;
                break;
              case 'large':
                customPosition.sizePx = 70;
                break;
              default:
                customPosition.sizePx = 50;
                break;
            }

            this.customPositions[customPosition.position_id] = customPosition;
          }, this));
        }

        this.settings.ctry = (this.api.properties.geoLocation && this.api.properties.geoLocation.ctry) ? this.api.properties.geoLocation.ctry : false;
        this.settings.views = (this.api.properties.views) ? this.api.properties.views : 1;
        this.settings.reflink = 'https://sumome.com/?src=sm-sh-' + this.api.properties.siteId + '&utm_source=sumo-powered-by&utm_medium=share&utm_campaign='+ this.api.properties.siteId;

        // Clears out positions so we can still try to render inline placements
        if (!$.isCurrentUrlAllowed(this.settings.display_rules, null, this.settings.ctry, this.settings.views)) {
          this.settings.positions = [];
        }

        this.install();
        this.fetch();
      } else {
        // do not load
      }
    },


    position: function() {
      var self = this;

      $('.sumome-share-client-wrapper-left-page, .sumome-share-client-wrapper-right-page').each(function() {
        var vh = $(window).height();
        var sh = $(this).outerHeight();
        var top = Math.max(Math.floor(vh - sh) / 2, 0);

        var position = $(this).hasClass('sumome-share-client-wrapper-left-page') ? 'lp' : 'rp';

        if (position in self.settings.position_settings) {
          if ('offset_x' in self.settings.position_settings[position]
            && self.settings.position_settings[position].offset_x != 0
          ) {
            if (position == 'lp')
              $(this).css('left', self.settings.position_settings[position].offset_x + 'px');
            else
              $(this).css('right', (0 - self.settings.position_settings[position].offset_x) + 'px');
          }

          if ('offset_y' in self.settings.position_settings[position]
            && self.settings.position_settings[position].offset_y != 0
          ) {
            top += self.settings.position_settings[position].offset_y;
          }
        }

        $(this).css('top', top + 'px');
      });

      $('.sumome-share-client-desktop-bottom-bar, .sumome-share-client-mobile-top-bar, .sumome-share-client-mobile-bottom-bar').each(function() {
        var position = $(this).data('sumome-share-pos');
        var sizePx = self.positionSettings[position].sizePx;
        var children = $(this).children();
        children.show();
        var vw = document.documentElement.clientWidth || document.body.clientWidth || $(window).width();
        var w = Math.max(sizePx, vw / children.length);
        var visible = Math.floor(vw / w);
        var hide = children.length - visible;
        var hidden = 0;
        var i = 0;
        while (hidden < hide && i < children.length) {
          var service = children.eq(children.length - 1 - i).data('sumome-share');
          if (service != 'sumome') {
            children.eq(children.length - 1 - i).hide();
            hidden++;
          }
          i++;
        }

        var childrenShown = children.length - hidden;
        var circle = false;
        var padding = 0;
        var position = $(this).data('sumome-share-pos');

        if (position in self.settings.position_settings && 'button_padding' in self.settings.position_settings[position]) {
          if ('button_style' in self.settings.position_settings[position] && self.settings.position_settings[position].button_style == 'circle')
            circle = true;

          padding = self.settings.position_settings[position].button_padding;
        } else if ('button_padding' in self.settings) {
          if ('button_style' in self.settings && self.settings.button_style == 'circle')
            circle = true;

          padding = self.settings.button_padding;
        }

        if (circle) {
          w = sizePx;
          children.css({ marginRight: ((vw - (w * childrenShown)) / (childrenShown - 1)) + 'px' });
        } else {
          if (padding)
            vw -= (childrenShown - 1) * padding;
          w = vw / childrenShown;
        }

        children.css({'width': w + 'px'});
        children.eq(childrenShown - 1).css('marginRight', 0);
      });

      // Loops through the custom placements
      $.each($('.sumome-share-client-custom'), $.proxy(function eachCustomShare(customIdx, customEl) {
        var $customEl = $(customEl);
        var lastTop = null;
        var multipleRows = false;
        var startingIdx = 0;
        var settings = this.positionSettings[$(customEl).data('sumome-share-pos')];

        // Checks if we're working with a horizontal bar with padding
        if (
          $customEl.hasClass('sumome-share-client-horizontal')
          && settings.button_padding > 0
        ) {
          var customChildren = $customEl.children();

          // Loops through the children to check position in bar
          $.each(customChildren, $.proxy(function eachCustomChild(buttonIdx, buttonEl) {
            if (lastTop !== $(buttonEl).offset().top) {
              startingIdx = buttonIdx;

              if (!multipleRows) {
                multipleRows = true;
              }
            }

            lastTop = $(buttonEl).offset().top;
          }, this));

          if (multipleRows) {
            $(customChildren).css('verticalAlign', 'top');

            for (var i = 0; i < startingIdx; i++) {
              $(customChildren[i]).css('marginBottom', settings.button_padding);
            }
          }
        }
      }, this));
    },

    updateTotals: function(delta) {
      this.settings['share'] += delta;
      var total = this.settings['share'];

      /*
      var total = 0;

      if (mode == 'mobile' && this.settings.use_mobile_services && this.settings.mobile_services.length)
        var services = this.settings.mobile_services.slice(0);
      else
        var services = this.settings.services.slice(0);

      services.forEach($.proxy(function(service) {
        if (service in this.settings) {
          total += parseInt(this.settings[service]);
        }
      }, this));

      this.settings['share'] = total;
      */

      var $shares = $('.sumome-share-client-share[data-sumome-share=share]');
      if (total >= this.settings.shares_minimum) {
        $shares.html('<span><strong>' + abbrNum(total) + '</strong><br>' + this.settings.shares_label + '</span>');
      } else {
        $shares.html('<span>' + this.settings.shares_label + '</span>');
      }
      var $openEl = $('.sumome-share-client-open-mobile');
      $openEl.find('span').remove();
      if (total >= this.settings.shares_minimum) {
        $openEl.append('<span>' + abbrNum(total) + '</span>');
      }

      // set custom counts here
      if (total >= this.settings.shares_minimum) {
        $('[data-sumome-share-count=share]').text(abbrNum(total));
      } else {
        $('[data-sumome-share-count=share]').text('');
      }

      this.alignShareLabels();
    },

    fetch: function(services) {
      var services = services || null;
      var forced = (services !== null);
      if (services === null) {
        services = [];

        for (var service in $.shareServices) {
          if ('background' in $.shareServices[service] && 'name' in $.shareServices[service] && 'fetch' in $.shareServices[service]) {
            console.log(service);
            services.push(service);
          }
        }
      }

      services.forEach((service) => {
        if (service in $.shareServices) {

          const isYummly = (service === 'yummly');

          if ((forced || (!(service in this.settings) && (!isYummly || (isYummly && this.settings.fetch_yummly))) || this.settings.fetch.indexOf(service) >= 0) && 'fetch' in $.shareServices[service] && 'parse' in $.shareServices[service]) {
            if (
              ['facebook','facebooklike'].indexOf(service) > -1
              && this.settings.has_facebook_token
            ) {
              try {
                $.ajax({
                  type: 'POST',
                  dataType: 'json',
                  xhrFields: {
                    withCredentials: false
                  },
                  crossDomain: true,
                  url: this.api.properties.sumoUrl + '/apps/share/facebook/queue',
                  data: {
                    site_id: this.api.properties.siteId,
                    url: getCurrentUri(),
                  },
                  success: $.proxy(function(data) {
                    var delta = this.updateCount(service, this.settings[service] + 1);
                    this.updateTotals(delta);
                  }, this)
                });
              } catch (e) {
              }
            } else {
              $.shareFetch(service, getCurrentUri(), $.proxy(function(err, url, count) {
                if (!err) {
                  console.log(service + ': ' + count);

                  var delta = this.updateCount(service, count);
                  this.updateTotals(delta);

                  try {
                    $.ajax({
                      type: 'POST',
                      dataType: 'json',
                      xhrFields: {
                        withCredentials: false
                      },
                      crossDomain: true,
                      url: this.api.properties.sumoUrl + "/api/jsonpcallback",
                      data: {
                        site_id: this.api.properties.siteId,
                        href: url,
                        service: service,
                        count: count
                      },
                      success: function(data) {
                      }
                    });
                  } catch (e) {
                  }
                }
              }, this));
            }
          }
        }
      });
    },

    updateCount: function updateCount(service, count) {
      var delta = (count || 0) - (this.settings[service] || 0);
      this.settings[service] = count;
      var $shares = $('.sumome-share-client-share[data-sumome-share=' + service + ']');

      $shares.each($.proxy(function(index, share) {
        var position = this.positionSettings[$(share).parent().data('sumome-share-pos')];
        if (position.shares_displayed && count >= 0 && count >= this.settings.shares_minimum) {
          $(share).addClass('sumome-share-client-count');
          $(share).find('span').remove();
          $(share).append('<span>' + abbrNum(count) + '</span>');
        } else {
          $(share).find('span').remove();
          $(share).removeClass('sumome-share-client-count');
        }
      }, this));

      // set custom counts here
      if (count >= 0 && count >= this.settings.shares_minimum) {
        $('[data-sumome-share-count=' + service + ']').text(abbrNum(count));
      } else {
        $('[data-sumome-share-count=' + service + ']').text('');
      }

      return delta;
    },

    install: function() {
      $(window).on('resize.sumome-share', $.debounce(300, function(e) {
        share.render();
      }));

      // If the DOM isn't already ready, then lets re-render when are
      if (false && !$.isReady) {
        $(document).ready($.proxy(function() {
          this.settings.current_mode = null;
          this.settings.articles = $(Articles.findAll());

          if (this.settings.articles.length > 1)
            this.settings.articles = $([]);

          this.render();
        }, this));
      }

      this.render();

      setInterval($.proxy(function() {this.bindCustomShares();}, this), 500);
    },

    remove: function() {
      $('.sumome-share-client-wrapper, .sumome-share-client-open-mobile').remove();
    },

    popupMobile: function(targetUrl, targetText) {
      $('.sumome-share-client-close-mobile').trigger('click');

      var $popupEl = $('<div class="sumome-share-mobile-popup" />').appendTo(document.body);
      var $closeEl = $('<div class="sumome-share-mobile-close-popup"><img src="' + require('../../../images/apps/9e8a4d2a-6f8c-415e-851b-bdfe4c01d5c1/close-white-60.png') + '" alt="Close Share"></div>');
      var $contEl = $('<ul />').appendTo($popupEl);

      $contEl.data('sumome-share-target-url', targetUrl);
      $contEl.data('sumome-share-target-text', targetText);

      $closeEl.appendTo($popupEl);

      $closeEl.click(function() {
        $(document.body).removeClass('sumome-share-mobile-popup-open');
        $popupEl.remove();
      });

      $(document.body).addClass('sumome-share-mobile-popup-open');
      this.renderPopupServices($contEl, false);
    },

    popup: function(targetUrl, targetText) {
      this.$modal = vex.open({
        content: '<h5>Share</h5><ul />',
        className: 'sumome-sharer-popup sumome-sharer-popup-small',
        overlayClassName: 'sumome-sharer-popup-overlay',
        contentClassName: 'sumome-sharer-popup-content',
        closeClassName: 'sumome-sharer-popup-close',
        overlayClosesOnClick: true
      });

      this.$modal.find('ul').data('sumome-share-target-url', targetUrl);
      this.$modal.find('ul').data('sumome-share-target-text', targetText);

      this.$modal.on('vexResize', $.proxy(function(e, options) {
        var paddings = Math.max(($(window).height() - options.$vexContent.outerHeight()) / 2, 0);
        options.$vex.css({
          'padding-top': paddings + 'px'
        });
      }, this));

      this.$modal.on('vexOpen', $.proxy(function(e, options) {
        this.renderPopupServices(this.$modal.find('ul'), true);
        this.$modal.resize();
        if (!this.settings.noSumoBranding)
          $('.sumome-sharer-popup-overlay').append('<a class="sumome-sharer-popup-link" href="' + this.settings.reflink + '" target="_blank">Powered by BDOW!</a>');
      }, this));

    },

    renderPopupServices: function($contEl, autoFocus) {
      var $input = $('<input type="text" />').attr('placeholder', 'Find a service');
      $input.insertBefore($contEl);
      if (!this.settings.noSumoBranding)
        $contEl.after('<a class="sumome-sharer-popup-link" href="' + this.settings.reflink + '" target="_blank">Powered by BDOW!</a>');

      $.shareSortedKeys.map($.proxy(function(service) {
        var data = $.shareServices[service];
        if ('background' in data && 'name' in data && service != 'sumome') {
          var el = $('<li data-service="' + service + '"><img src="' + require('../../../images/apps/9e8a4d2a-6f8c-415e-851b-bdfe4c01d5c1/' + service + '-' + (this.settings.color ? Color.whiteOrBlack(this.settings.color) : 'white') + '-60.png') + '" alt="' + data.name + '">' + data.name + '</li>').data('sumome-share', service);
          $contEl.append(el);
          el.find('img').css('background', this.settings.color ? this.settings.color : (('background' in data) ? data.background : '#ccc'));
        }
      }, this));

      $contEl.on('click', 'li', $.proxy(function(e) {
        var service = $(e.currentTarget).data('service');
        var targetUrl = $(e.delegateTarget).data('sumome-share-target-url') || getCurrentUri();
        var targetText = $(e.delegateTarget).data('sumome-share-target-text');

        if (service != 'share') {
          this.api.emit('event', { 'appId': '9e8a4d2a-6f8c-415e-851b-bdfe4c01d5c1', 'event': service + '-click', 'href': targetUrl });

          if (service === 'twitter') {
            if (
              $('meta[name="twitter:title"]').length
              && 'undefined' === typeof $(e.currentTarget).data('sumome-share-text')
            ) {
              targetText = $('meta[name="twitter:title"]').eq(0).attr('content');
            }

            if (
              $('meta[name="twitter:url"]').length
              && 'undefined' === typeof $(e.currentTarget).data('sumome-share-url')
            ) {
              targetUrl = $('meta[name="twitter:url"]').eq(0).attr('content');
            }
          }

          var data = {
            url: targetUrl,
            text: targetText,
            siteId: this.api.properties.siteId,
            sumoUrl: this.api.properties.sumoUrl,
            shortenUrl: this.settings.use_shortener,
            shortener: this.settings.shortener + this.settings.short_domain,
            noSumoBranding: this.settings.noSumoBranding,
          };
          if ('services_settings' in this.settings && this.settings.services_settings && service in this.settings.services_settings) {
            $.extend(data, this.settings.services_settings[service]);
          }
          if (this.settings.noSumoBranding && 'url' in data && data.url && 'utm' in this.settings && this.settings.utm) {
            var uri = URI(data.url);
            if ('utm_source' in this.settings && this.settings.utm_source) {
              uri.removeQuery('utm_source');
              uri.addQuery('utm_source', this.settings.utm_source.replace('{service}', service));
            }

            if ('utm_medium' in this.settings && this.settings.utm_medium) {
              uri.removeQuery('utm_medium');
              uri.addQuery('utm_medium', this.settings.utm_medium.replace('{service}', service));
            }

            if ('utm_name' in this.settings && this.settings.utm_name) {
              uri.removeQuery('utm_campaign');
              uri.addQuery('utm_campaign', this.settings.utm_name.replace('{service}', service));
            }

            if ('utm_custom_key' in this.settings && this.settings.utm_custom_key) {
              if ('utm_custom_val' in this.settings && this.settings.utm_custom_val) {
                uri.removeQuery(this.settings.utm_custom_key);
                uri.addQuery(this.settings.utm_custom_key.replace('{service}', service), this.settings.utm_custom_val.replace('{service}', service));
              }
            }

            data.url = uri.toString();
          }
          $.share(service, data, $.proxy(function(service) {this.fetch([service]);}, this));
          //setTimeout($.proxy(function() {this.fetch([service]);}, this), 1000 * 30);
        }

        // Closes modal for services that inject stuff below the overlay
        if (['fancy','kaboodle','printerfriendly','slashdot'].indexOf(service) > -1)
          $('.sumome-vex-close', this.$modal).trigger('click');
      }, this));

      $input.on('keyup', function() {
        var text = ($(this).val() + '').trim().toLowerCase();
        var $services = $(this).next('ul');

        for (var service in $.shareServices) {
          var data = $.shareServices[service];
          if ('background' in data && 'name' in data) {
            var name = data['name'].toLowerCase();
            var found = text == '' ? true : (name.indexOf(text) >= 0);

            $services.find('li[data-service="' + service + '"]').toggle(found);
          }
        }
      });

      if (autoFocus)
        $input.focus();
    },

    render: function() {
      console.log('rendering share...');
      var articles = this.settings.articles;
      var width = Math.min(window.screen.availWidth || $(window).width(),  $(window).width());
      var mode = width <= this.settings.mobile_width ? 'mobile' : 'desktop';

      // Do not rebuild everything if we're already set for the current mode
      if ('current_mode' in this.settings && mode == this.settings.current_mode) {
        // Desktop positions need to be updated on a window resize
        //if (mode == 'desktop')
        this.position();
        return;
      }

      this.remove();

      // No positions enabled
      if (this.positionSettings.length == 0) {
        console.log('no positions...');
        return;
      }

      // Set the current mode
      this.settings.current_mode = mode;

      var sizePx = 50;

      if (this.settings.size == 'large')
        sizePx = 70;
      else if (this.settings.size == 'small')
        sizePx = 30;

      if (mode == 'mobile') {
        console.log('rendering for mobile...');

        if ('positions' in this.settings && this.settings.positions.indexOf('mbt') >= 0) {
          $('body').append('<div data-sumome-stylebuffer-top="90" data-sumome-stylebuffertop-offsety="' + this.positionSettings.mbt.offset_y + '" class="sumome-share-client-wrapper sumome-share-client-wrapper-mobile-top-bar' + (this.positionSettings.mbt.shares_displayed ? ' sumome-share-client-counts' : '') + ' sumome-share-client-' + this.settings.theme + ' sumome-share-client-' + this.positionSettings.mbt.size + '"><div data-sumome-share-pos="mbt" class="sumome-share-client sumome-share-client-mobile-top-bar' + (this.positionSettings.mbt.shares_displayed ? ' sumome-share-client-counts' : '') + ' sumome-share-client-' + this.settings.theme + ' sumome-share-client-' + this.positionSettings.mbt.size + '"></div></div>');

          $('body').styleBufferTop();
        }

        if ('positions' in this.settings && this.settings.positions.indexOf('mbb') >= 0) {
          $('body').append('<div data-sumome-stylebuffer-bottom="90" data-sumome-stylebufferbottom-offsety="' + (0 - this.positionSettings.mbb.offset_y) + '" class="sumome-share-client-wrapper sumome-share-client-wrapper-mobile-bottom-bar' + (this.positionSettings.mbb.shares_displayed ? ' sumome-share-client-counts' : '') + ' sumome-share-client-' + this.settings.theme + ' sumome-share-client-' + this.positionSettings.mbb.size + '"><div data-sumome-share-pos="mbb" class="sumome-share-client sumome-share-client-mobile-bottom-bar' + (this.positionSettings.mbb.shares_displayed ? ' sumome-share-client-counts' : '') + ' sumome-share-client-' + this.settings.theme + ' sumome-share-client-' + this.positionSettings.mbb.size + '"></div></div>');

          $('body').styleBufferBottom();

          if(this.settings.scroll_view){
            this.$mobileBottomBar = $('.sumome-share-client-wrapper-mobile-bottom-bar');
            this.$mobileBottomBar.css('bottom', this.$mobileBottomBar.height()*(-1));
            this.$mobileBottomBar.addClass('sumome-share-client-wrapper-mobile-bottom-bar-scroll');
            this.$mobileBottomBar.addClass('sumome-share-client-wrapper-mobile-bottom-bar-hidden');
            this.lastScrollTop = $(window).scrollTop();
            $(window).on('scroll', $.debounce(1, function() { share.scroll(); }));
          }
        }

        if ('positions' in this.settings && this.settings.positions.indexOf('mbl') >= 0) {
          var openEl = $('<div class="sumome-share-client-open-mobile sumome-share-client-open-mobile-left' + (this.positionSettings.mbl.total_shares_displayed ? ' sumome-share-client-counts' : '') + ' sumome-share-client-' + this.settings.theme + ' sumome-share-client-' + this.positionSettings.mbl.size + '"><img src="' + require('../../../images/apps/9e8a4d2a-6f8c-415e-851b-bdfe4c01d5c1/share-black-60.png') + '" alt="Open Share"></div>');
          var closeEl = $('<div class="sumome-share-client-close-mobile sumome-share-client-close-mobile-left' + (this.positionSettings.mbl.shares_displayed ? ' sumome-share-client-counts' : '') + ' sumome-share-client-' + this.settings.theme + ' sumome-share-client-' + this.positionSettings.mbl.size + '"><img src="' + require('../../../images/apps/9e8a4d2a-6f8c-415e-851b-bdfe4c01d5c1/close-white-60.png') + '" alt="Close Share"></div>');
          var wrapperEl = $('<div class="sumome-share-client-wrapper sumome-share-client-wrapper-mobile sumome-share-client-wrapper-mobile-left' + (this.positionSettings.mbl.shares_displayed ? ' sumome-share-client-counts' : '') + ' sumome-share-client-' + this.settings.theme + ' sumome-share-client-' + this.positionSettings.mbl.size + '"></div>');
          var clientEl = $('<div class="sumome-share-client-mobile sumome-share-client-mobile-left' + (this.settings.list_view ? ' sumome-share-client-mobile-list' : '') + (this.positionSettings.mbl.shares_displayed ? ' sumome-share-client-counts' : '') + ' sumome-share-client-' + this.settings.theme + ' sumome-share-client-' + this.positionSettings.mbl.size + '"></div>');

          $('body').append(openEl);
          wrapperEl.append(clientEl);
          clientEl.append(closeEl);
          $('body').append(wrapperEl);

          if (this.positionSettings.mbl.total_shares_displayed && 'share' in this.settings && parseInt(this.settings['share']) >= this.settings.shares_minimum)
            openEl.append('<span>' + ('share' in this.settings ? abbrNum(this.settings['share']) : '0') + '</span>');

          if (this.positionSettings.mbl.total_shares_displayed && (this.settings.shares_label || this.settings.shares_minimum <= 0 || !('share' in this.settings) || parseInt(this.settings['share']) >= this.settings.shares_minimum)) {
            var el = $('<div class="sumome-share-client-animated sumome-share-client-share sumome-share-client-share-share sumome-share-client-count" data-sumome-share="share"></div>');
            if (this.positionSettings.mbl.total_shares_displayed && 'share' in this.settings && parseInt(this.settings['share']) >= this.settings.shares_minimum)
              el.append('<span><strong>' + ('share' in this.settings ? abbrNum(this.settings['share']) : '0') + '</strong><br>' + this.settings.shares_label + '</span>');
            else
              el.append('<span>' + this.settings.shares_label + '</span>');
            el.css('background', 'transparent');
            el.css('color', '#fff');
            var rowEl = $('<div class="sumome-row"></div>');
            var colEl = $('<div class="sumome-12 sumome-columns sumome-text-center"></div>');
            colEl.append(el);
            rowEl.append(colEl);
            clientEl.append(rowEl);
          }

          var $share = $('<div class="sumome-row sumome-share-services"></div>');
          clientEl.append($share);

          var servicesDisplayed = 0;

          this.positionSettings.mbl.services.forEach($.proxy(function(service) {
            if (servicesDisplayed < this.positionSettings.mbl.services_displayed || service === 'sumome') {
              var el = $('<div class="sumome-share-client-animated sumome-share-client-share"' + (this.settings.list_view ? '' : ' data-sumome-share="' + service + '"') + '"><img src="' + require('../../../images/apps/9e8a4d2a-6f8c-415e-851b-bdfe4c01d5c1/' + (this.settings.noSumoBranding && service === 'sumome' ? 'sumomepro' : service) + '-' + (this.positionSettings.mbl.color ? Color.whiteOrBlack(this.positionSettings.mbl.color) : 'white') + '-60.png') + '" alt="' + (service === 'sumome' ? 'More' : $.shareServices[service].name) + '"></div>');
              if (this.positionSettings.mbl.shares_displayed && service in this.settings && parseInt(this.settings[service]) >= this.settings.shares_minimum) {
                el.addClass('sumome-share-client-count');
                el.append('<span>' + (service in this.settings ? abbrNum(this.settings[service]) : '0') + '</span>');
              }
              el.css('background', this.positionSettings.mbl.color ? this.positionSettings.mbl.color : (('background' in $.shareServices[service]) ? $.shareServices[service].background : '#ccc'));
              el.css('color', this.positionSettings.mbl.color ? Color.whiteOrBlack(this.positionSettings.mbl.color) : ('color' in $.shareServices[service] ? $.shareServices[service].color : '#fff'));
              var colEl = $('<div class="sumome-4 sumome-columns' + (this.settings.list_view ? '" data-sumome-share="' + service + '"' : ' sumome-text-center"') + '></div>');
              colEl.append(el);
              if(this.settings.list_view) {
                var nameTitle = (('name' in $.shareServices[service]) ? $.shareServices[service].name : service);
                if(nameTitle == 'SumoMe') nameTitle = 'More';
                colEl.append(nameTitle);
              }
              $share.append(colEl);
              if (service != 'sumome')
                servicesDisplayed++;
            }
          }, this));

          console.log($share.find('.sumome-columns'));
          console.log($share.find('.sumome-columns').last());

          $share.find('.sumome-columns').last().addClass('sumome-end');

          $('.sumome-share-client-open-mobile-left').on('click', $.proxy(function(e) {
            $('.sumome-share-client-open-mobile-left').hide();
            $('.sumome-share-client-wrapper-mobile-left').show();
            $(document.body).addClass('sumome-share-mobile-popup-open');
          }, this));

          $('.sumome-share-client-close-mobile-left').on('click', $.proxy(function(e) {
            $('.sumome-share-client-wrapper-mobile-left').hide();
            $('.sumome-share-client-open-mobile-left').show();
            $(document.body).removeClass('sumome-share-mobile-popup-open');
          }, this));
        }

        if ('positions' in this.settings && this.settings.positions.indexOf('mbr') >= 0) {
          var openEl = $('<div class="sumome-share-client-open-mobile sumome-share-client-open-mobile-right' + (this.positionSettings.mbr.total_shares_displayed ? ' sumome-share-client-counts' : '') + ' sumome-share-client-' + this.settings.theme + ' sumome-share-client-' + this.positionSettings.mbr.size + '"><img src="' + require('../../../images/apps/9e8a4d2a-6f8c-415e-851b-bdfe4c01d5c1/share-black-60.png') + '" alt="Open Share"></div>');
          var closeEl = $('<div class="sumome-share-client-close-mobile sumome-share-client-close-mobile-right' + (this.positionSettings.mbr.shares_displayed ? ' sumome-share-client-counts' : '') + ' sumome-share-client-' + this.settings.theme + ' sumome-share-client-' + this.positionSettings.mbr.size + '"><img src="' + require('../../../images/apps/9e8a4d2a-6f8c-415e-851b-bdfe4c01d5c1/close-white-60.png') + '" alt="Close Share"></div>');
          var wrapperEl = $('<div class="sumome-share-client-wrapper sumome-share-client-wrapper-mobile sumome-share-client-wrapper-mobile-right' + (this.positionSettings.mbr.shares_displayed ? ' sumome-share-client-counts' : '') + ' sumome-share-client-' + this.settings.theme + ' sumome-share-client-' + this.positionSettings.mbr.size + '"></div>');
          var clientEl = $('<div class="sumome-share-client-mobile sumome-share-client-mobile-right' + (this.positionSettings.mbr.shares_displayed ? ' sumome-share-client-counts' : '') + ' sumome-share-client-' + this.settings.theme + ' sumome-share-client-' + this.positionSettings.mbr.size + '"></div>');

          $('body').append(openEl);
          wrapperEl.append(clientEl);
          clientEl.append(closeEl);
          $('body').append(wrapperEl);

          if (this.positionSettings.mbr.total_shares_displayed && 'share' in this.settings && parseInt(this.settings['share']) >= this.settings.shares_minimum)
            openEl.append('<span>' + ('share' in this.settings ? abbrNum(this.settings['share']) : '0') + '</span>');

          if (this.positionSettings.mbr.total_shares_displayed && (this.settings.shares_label || this.settings.shares_minimum <= 0 || !('share' in this.settings) || parseInt(this.settings['share']) >= this.settings.shares_minimum)) {
            var el = $('<div class="sumome-share-client-animated sumome-share-client-share sumome-share-client-share-share sumome-share-client-count" data-sumome-share="share"></div>');
            if (this.positionSettings.mbr.total_shares_displayed && 'share' in this.settings && parseInt(this.settings['share']) >= this.settings.shares_minimum)
              el.append('<span><strong>' + ('share' in this.settings ? abbrNum(this.settings['share']) : '0') + '</strong><br>' + this.settings.shares_label + '</span>');
            else
              el.append('<span>' + this.settings.shares_label + '</span>');
            el.css('background', 'transparent');
            el.css('color', '#fff');
            var rowEl = $('<div class="sumome-row"></div>');
            var colEl = $('<div class="sumome-12 sumome-columns sumome-text-center"></div>');
            colEl.append(el);
            rowEl.append(colEl);
            clientEl.append(rowEl);
          }

          var $share = $('<div class="sumome-row"></div>');
          clientEl.append($share);

          var servicesDisplayed = 0;

          this.positionSettings.mbr.services.forEach($.proxy(function(service) {
            if (servicesDisplayed < this.positionSettings.mbr.services_displayed || service === 'sumome') {
              var el = $('<div class="sumome-share-client-animated sumome-share-client-share" data-sumome-share="' + service + '"><img src="' + require('../../../images/apps/9e8a4d2a-6f8c-415e-851b-bdfe4c01d5c1/' + (this.settings.noSumoBranding && service === 'sumome' ? 'sumomepro' : service) + '-' + (this.positionSettings.mbr.color ? Color.whiteOrBlack(this.positionSettings.mbr.color) : 'white') + '-60.png') + '" alt="' + (this.settings.noSumoBranding && service === 'sumome' ? 'More' : $.shareServices[service].name) + '"></div>');
              if (this.positionSettings.mbr.shares_displayed && service in this.settings && parseInt(this.settings[service]) >= this.settings.shares_minimum) {
                el.addClass('sumome-share-client-count');
                el.append('<span>' + (service in this.settings ? abbrNum(this.settings[service]) : '0') + '</span>');
              }
              el.css('background', this.positionSettings.mbr.color ? this.positionSettings.mbr.color : (('background' in $.shareServices[service]) ? $.shareServices[service].background : '#ccc'));
              el.css('color', this.positionSettings.mbr.color ? Color.whiteOrBlack(this.positionSettings.mbr.color) : ('color' in $.shareServices[service] ? $.shareServices[service].color : '#fff'));
              var colEl = $('<div class="sumome-4 sumome-columns sumome-text-center"></div>');
              colEl.append(el);
              $share.append(colEl);
              if (service != 'sumome')
                servicesDisplayed++;
            }
          }, this));

          console.log($share.find('.sumome-columns'));
          console.log($share.find('.sumome-columns').last());

          $share.find('.sumome-columns').last().addClass('sumome-end');

          $('.sumome-share-client-open-mobile-right').on('click', $.proxy(function(e) {
            $('.sumome-share-client-open-mobile-right').hide();
            $('.sumome-share-client-wrapper-mobile-right').show();
            $(document.body).addClass('sumome-share-mobile-popup-open');
          }, this));

          $('.sumome-share-client-close-mobile-right').on('click', $.proxy(function(e) {
            $('.sumome-share-client-wrapper-mobile-right').hide();
            $('.sumome-share-client-open-mobile-right').show();
            $(document.body).removeClass('sumome-share-mobile-popup-open');
          }, this));
        }
      } else {
        console.log('rendering for desktop...');

        $.fn.styleBuffer._update();

        if ('positions' in this.settings && this.settings.positions.indexOf('la') >= 0) {
          //articles.unstatic().append('<div data-sumome-share-pos="la" class="sumome-share-client sumome-share-client-left-article"></div>');
        }

        if ('positions' in this.settings && this.settings.positions.indexOf('ra') >= 0) {
          //articles.unstatic().append('<div data-sumome-share-pos="ra" class="sumome-share-client sumome-share-client-right-article"></div>');
        }

        if ('positions' in this.settings && this.settings.positions.indexOf('ra') >= 0) {
          articles.unstatic();
          articles.styleBuffer('padding', 'right', 20 + this.positionSettings.ra.sizePx);
          var self = this;
          articles.each(function() {
            var offset = parseInt($(this).css('padding-right').replace('px', '')) - (sizePx + 10);
            var wrapperEl = $('<div class="sumome-share-client-wrapper sumome-share-client-wrapper-right-sidebar' + (self.positionSettings.ra.shares_displayed ? ' sumome-share-client-counts' : '') + ' sumome-share-client-' + self.settings.theme + ' sumome-share-client-' + self.positionSettings.ra.size + '"></div>');
            var clientEl = $('<div data-sumome-share-pos="ra" class="sumome-share-client sumome-share-client-right-sidebar-article' + (self.positionSettings.ra.shares_displayed ? ' sumome-share-client-counts' : '') + ' sumome-share-client-' + self.settings.theme + ' sumome-share-client-' + self.positionSettings.ra.size + '"></div>');
            wrapperEl.append(clientEl);
            if (this._header) {
              var top = this._header.position().top;
              var height = this._header.outerHeight();
              wrapperEl.css('top', (top + height) + 'px');
            }
            wrapperEl.css('right', offset + 'px');
            //if (this._title) {
            //  this._title.after(wrapperEl);
            //} else {
              $(this).prepend(wrapperEl);
            //}
            //clientEl.data('sumome-share-target-url', this._url);
            //clientEl.data('sumome-share-target-text', this._titleText);
          });
        }

        if ('positions' in this.settings && this.settings.positions.indexOf('la') >= 0) {
          articles.unstatic();
          articles.styleBuffer('padding', 'left', 2 + this.positionSettings.la.sizePx);
          var self = this;
          articles.each(function() {
            var offset = parseInt($(this).css('padding-left').replace('px', '')) - (10 + sizePx);
            var wrapperEl = $('<div class="sumome-share-client-wrapper sumome-share-client-wrapper-left-sidebar' + (self.positionSettings.la.shares_displayed ? ' sumome-share-client-counts' : '') + ' sumome-share-client-' + self.settings.theme + ' sumome-share-client-' + self.positionSettings.la.size + '"></div>');
            var clientEl = $('<div data-sumome-share-pos="la" class="sumome-share-client sumome-share-client-left-sidebar-article' + (self.positionSettings.la.shares_displayed ? ' sumome-share-client-counts' : '') + ' sumome-share-client-' + self.settings.theme + ' sumome-share-client-' + self.positionSettings.la.size + '"></div>');
            wrapperEl.append(clientEl);
            if (this._header) {
              var top = this._header.position().top;
              var height = this._header.outerHeight();
              wrapperEl.css('top', (top + height) + 'px');
            }
            wrapperEl.css('left', offset + 'px');
            //if (this._title) {
              //this._title.after(wrapperEl);
            //} else {
              $(this).prepend(wrapperEl);
            //}
            //clientEl.data('sumome-share-target-url', this._url);
            //clientEl.data('sumome-share-target-text', this._titleText);
          });
        }

        if ('positions' in this.settings && this.settings.positions.indexOf('hra') >= 0) {
          articles.unstatic();
          var self = this;
          articles.each(function() {
            //console.log('article:', $(this).get(0));
            //console.log('title: ', this._titleText);
            //console.log('url: ', this._url);
            var wrapperEl = $('<div class="sumome-share-client-wrapper sumome-share-client-wrapper-right' + (self.positionSettings.hra.shares_displayed ? ' sumome-share-client-counts' : '') + ' sumome-share-client-' + self.settings.theme + ' sumome-share-client-' + self.positionSettings.hra.size + '"></div>');
            var clientEl = $('<div data-sumome-share-pos="hra" class="sumome-share-client sumome-share-client-header-right-article' + (self.positionSettings.hra.shares_displayed ? ' sumome-share-client-counts' : '') + ' sumome-share-client-' + self.settings.theme + ' sumome-share-client-' + self.positionSettings.hra.size + '"></div>');
            wrapperEl.append(clientEl);
            if (this._header) {
              this._header.after(wrapperEl);
            } else {
              $(this).prepend(wrapperEl);
            }
            //clientEl.data('sumome-share-target-url', this._url);
            //clientEl.data('sumome-share-target-text', this._titleText);
          });
        }

        if ('positions' in this.settings && this.settings.positions.indexOf('hca') >= 0) {
          articles.unstatic();
          var self = this;
          articles.each(function() {
            var wrapperEl = $('<div class="sumome-share-client-wrapper sumome-share-client-wrapper-center' + (self.positionSettings.hca.shares_displayed ? ' sumome-share-client-counts' : '') + ' sumome-share-client-' + self.settings.theme + ' sumome-share-client-' + self.positionSettings.hca.size + '"></div>');
            var clientEl = $('<div data-sumome-share-pos="hca" class="sumome-share-client sumome-share-client-header-center-article' + (self.positionSettings.hca.shares_displayed ? ' sumome-share-client-counts' : '') + ' sumome-share-client-' + self.settings.theme + ' sumome-share-client-' + self.positionSettings.hca.size + '"></div>');
            wrapperEl.append(clientEl);
            if (this._header) {
              this._header.after(wrapperEl);
            } else {
              $(this).prepend(wrapperEl);
            }
            //clientEl.data('sumome-share-target-url', this._url);
            //clientEl.data('sumome-share-target-text', this._titleText);
          });
        }

        if ('positions' in this.settings && this.settings.positions.indexOf('hla') >= 0) {
          articles.unstatic();
          var self = this;
          articles.each(function() {
            var wrapperEl = $('<div class="sumome-share-client-wrapper sumome-share-client-wrapper-left' + (self.positionSettings.hla.shares_displayed ? ' sumome-share-client-counts' : '') + ' sumome-share-client-' + self.settings.theme + ' sumome-share-client-' + self.positionSettings.hla.size + '"></div>');
            var clientEl = $('<div data-sumome-share-pos="hla" class="sumome-share-client sumome-share-client-header-left-article' + (self.positionSettings.hla.shares_displayed ? ' sumome-share-client-counts' : '') + ' sumome-share-client-' + self.settings.theme + ' sumome-share-client-' + self.positionSettings.hla.size + '"></div>');
            wrapperEl.append(clientEl);
            if (this._header) {
              this._header.after(wrapperEl);
            } else {
              $(this).prepend(wrapperEl);
            }
            //clientEl.data('sumome-share-target-url', this._url);
            //clientEl.data('sumome-share-target-text', this._titleText);
          });
        }

        if ('positions' in this.settings && this.settings.positions.indexOf('tra') >= 0) {
          articles.unstatic();
          var self = this;
          articles.each(function() {
            //console.log('article:', $(this).get(0));
            //console.log('title: ', this._titleText);
            //console.log('url: ', this._url);
            var wrapperEl = $('<div class="sumome-share-client-wrapper sumome-share-client-wrapper-right' + (self.positionSettings.tra.shares_displayed ? ' sumome-share-client-counts' : '') + ' sumome-share-client-' + self.settings.theme + ' sumome-share-client-' + self.positionSettings.tra.size + '"></div>');
            var clientEl = $('<div data-sumome-share-pos="tra" class="sumome-share-client sumome-share-client-top-right-article' + (self.positionSettings.tra.shares_displayed ? ' sumome-share-client-counts' : '') + ' sumome-share-client-' + self.settings.theme + ' sumome-share-client-' + self.positionSettings.tra.size + '"></div>');
            wrapperEl.append(clientEl);
            $(this).prepend(wrapperEl);
            //clientEl.data('sumome-share-target-url', this._url);
            //clientEl.data('sumome-share-target-text', this._titleText);
          });
        }

        if ('positions' in this.settings && this.settings.positions.indexOf('tca') >= 0) {
          articles.unstatic();
          var self = this;
          articles.each(function() {
            var wrapperEl = $('<div class="sumome-share-client-wrapper sumome-share-client-wrapper-center' + (self.positionSettings.tca.shares_displayed ? ' sumome-share-client-counts' : '') + ' sumome-share-client-' + self.settings.theme + ' sumome-share-client-' + self.positionSettings.tca.size + '"></div>');
            var clientEl = $('<div data-sumome-share-pos="tca" class="sumome-share-client sumome-share-client-top-center-article' + (self.positionSettings.tca.shares_displayed ? ' sumome-share-client-counts' : '') + ' sumome-share-client-' + self.settings.theme + ' sumome-share-client-' + self.positionSettings.tca.size + '"></div>');
            wrapperEl.append(clientEl);
            $(this).prepend(wrapperEl);
            //clientEl.data('sumome-share-target-url', this._url);
            //clientEl.data('sumome-share-target-text', this._titleText);
          });
        }

        if ('positions' in this.settings && this.settings.positions.indexOf('tla') >= 0) {
          articles.unstatic();
          var self = this;
          articles.each(function() {
            var wrapperEl = $('<div class="sumome-share-client-wrapper sumome-share-client-wrapper-left' + (self.positionSettings.tla.shares_displayed ? ' sumome-share-client-counts' : '') + ' sumome-share-client-' + self.settings.theme + ' sumome-share-client-' + self.positionSettings.tla.size + '"></div>');
            var clientEl = $('<div data-sumome-share-pos="tla" class="sumome-share-client sumome-share-client-top-left-article' + (self.positionSettings.tla.shares_displayed ? ' sumome-share-client-counts' : '') + ' sumome-share-client-' + self.settings.theme + ' sumome-share-client-' + self.positionSettings.tla.size + '"></div>');
            wrapperEl.append(clientEl);
            $(this).prepend(wrapperEl);
            //clientEl.data('sumome-share-target-url', this._url);
            //clientEl.data('sumome-share-target-text', this._titleText);
          });
        }

        if ('positions' in this.settings && this.settings.positions.indexOf('bra') >= 0) {
          articles.unstatic().append('<div class="sumome-share-client-wrapper sumome-share-client-wrapper-right' + (this.positionSettings.bra.shares_displayed ? ' sumome-share-client-counts' : '') + ' sumome-share-client-' + this.settings.theme + ' sumome-share-client-' + this.positionSettings.bra.size + '"><div data-sumome-share-pos="bra" class="sumome-share-client sumome-share-client-bottom-right-article' + (this.positionSettings.bra.shares_displayed ? ' sumome-share-client-counts' : '') + ' sumome-share-client-' + this.settings.theme + ' sumome-share-client-' + this.positionSettings.bra.size + '"></div></div>');
        }

        if ('positions' in this.settings && this.settings.positions.indexOf('bca') >= 0) {
          articles.unstatic().append('<div class="sumome-share-client-wrapper sumome-share-client-wrapper-center' + (this.positionSettings.bca.shares_displayed ? ' sumome-share-client-counts' : '') + ' sumome-share-client-' + this.settings.theme + ' sumome-share-client-' + this.positionSettings.bca.size + '"><div data-sumome-share-pos="bca" class="sumome-share-client sumome-share-client-bottom-center-article' + (this.positionSettings.bca.shares_displayed ? ' sumome-share-client-counts' : '') + ' sumome-share-client-' + this.settings.theme + ' sumome-share-client-' + this.positionSettings.bca.size + '"></div></div>');
        }

        if ('positions' in this.settings && this.settings.positions.indexOf('bla') >= 0) {
          articles.unstatic().append('<div class="sumome-share-client-wrapper sumome-share-client-wrapper-left' + (this.positionSettings.bla.shares_displayed ? ' sumome-share-client-counts' : '') + ' sumome-share-client-' + this.settings.theme + ' sumome-share-client-' + this.positionSettings.bla.size + '"><div data-sumome-share-pos="bla" class="sumome-share-client sumome-share-client-bottom-left-article' + (this.positionSettings.bla.shares_displayed ? ' sumome-share-client-counts' : '') + ' sumome-share-client-' + this.settings.theme + ' sumome-share-client-' + this.positionSettings.bla.size + '"></div></div>');
        }

        if ('positions' in this.settings && this.settings.positions.indexOf('lp') >= 0) {
          $('body').append('<div class="sumome-share-client-wrapper sumome-share-client-wrapper-left-page' + (this.positionSettings.lp.shares_displayed ? ' sumome-share-client-counts' : '') + ' sumome-share-client-' + this.settings.theme + ' sumome-share-client-' + this.positionSettings.lp.size + '"><div data-sumome-share-pos="lp" class="sumome-share-client sumome-share-client-left-page' + (this.positionSettings.lp.shares_displayed ? ' sumome-share-client-counts' : '') + ' sumome-share-client-' + this.settings.theme + ' sumome-share-client-' + this.positionSettings.lp.size + '"></div></div>');
        }

        if ('positions' in this.settings && this.settings.positions.indexOf('rp') >= 0) {
          $('body').append('<div class="sumome-share-client-wrapper sumome-share-client-wrapper-right-page' + (this.positionSettings.rp.shares_displayed ? ' sumome-share-client-counts' : '') + ' sumome-share-client-' + this.settings.theme + ' sumome-share-client-' + this.positionSettings.rp.size + '"><div data-sumome-share-pos="rp" class="sumome-share-client sumome-share-client-right-page' + (this.positionSettings.rp.shares_displayed ? ' sumome-share-client-counts' : '') + ' sumome-share-client-' + this.settings.theme + ' sumome-share-client-' + this.positionSettings.rp.size + '"></div></div>');
        }

        if ('positions' in this.settings && this.settings.positions.indexOf('dbb') >= 0) {
          $('body').append('<div data-sumome-stylebuffer-bottom="90" data-sumome-stylebufferbottom-offsety="' + (0 - this.positionSettings.dbb.offset_y) + '" class="sumome-share-client-wrapper sumome-share-client-wrapper-desktop-bottom-bar' + (this.positionSettings.dbb.shares_displayed ? ' sumome-share-client-counts' : '') + ' sumome-share-client-' + this.settings.theme + ' sumome-share-client-' + this.positionSettings.dbb.size + '"><div data-sumome-share-pos="dbb" class="sumome-share-client sumome-share-client-desktop-bottom-bar' + (this.positionSettings.dbb.shares_displayed ? ' sumome-share-client-counts' : '') + ' sumome-share-client-' + this.settings.theme + ' sumome-share-client-' + this.positionSettings.dbb.size + '"></div></div>');

          $('body').styleBufferBottom();
        }

        if ('positions' in this.settings && (this.settings.positions.indexOf('lp') >= 0 || this.settings.positions.indexOf('rp') >= 0)) {
          var showEl = $('<div class="sumome-share-client-show"><span /></div>');
          $('.sumome-share-client-wrapper-left-page, .sumome-share-client-wrapper-right-page').prepend(showEl);

          var hideEl = $('<div class="sumome-share-client-hide"><span /></div>');
          $('.sumome-share-client-wrapper-left-page, .sumome-share-client-wrapper-right-page').append(hideEl);

          $('.sumome-share-client-wrapper-left-page, .sumome-share-client-wrapper-right-page').hover(function() {
            if (!$(this).hasClass('sumome-share-client-hidden')) {
              $(this).find('.sumome-share-client-hide').fadeIn('fast');
            }
          }, function() {
            $(this).find('.sumome-share-client-hide').fadeOut('fast');
          });

          $('.sumome-share-client-hide').click(function() {
            var $wrapper = $(this).closest('.sumome-share-client-wrapper');
            var isLeft = $wrapper.hasClass('sumome-share-client-wrapper-left-page');
            $wrapper.data('sumome-share-original-position', $wrapper.css(isLeft ? 'left' : 'right'));
            $wrapper.animate(isLeft ? {left: '-' + sizePx + 'px'} : {right: '-' + sizePx + 'px'}, 'fast', function() {
              $(this).addClass('sumome-share-client-hidden');
              $(this).find('.sumome-share-client-hide').hide();
              $(this).animate(isLeft ? {left: '0px'} : {right: '0px'}, 'fast');
            });
          });

          $('.sumome-share-client-show').click(function() {
            var $wrapper = $(this).closest('.sumome-share-client-wrapper');
            var isLeft = $wrapper.hasClass('sumome-share-client-wrapper-left-page');
            var position = $wrapper.data('sumome-share-original-position');
            $wrapper.animate(isLeft ? {left: '-' + sizePx + 'px'} : {right: '-' + sizePx + 'px'}, 'fast', function() {
              $(this).removeClass('sumome-share-client-hidden');
              $(this).find('.sumome-share-client-hide').show();
              $(this).animate(isLeft ? {left: position} : {right: position}, 'fast');
            });
          });
        }
      }

      this.addButtons($('.sumome-share-client'), mode);
      this.applyPositionSettings();
      this.position();
      this.alignShareLabels();
      this.updateCustomCounts();

      // Binds mobile corner buttons since they don't get buttons appended above
      $('.sumome-share-client-share', $('.sumome-share-client-mobile-right,.sumome-share-client-mobile-left')).on('click', $.proxy(function(e) {this.click(e);}, this));

      this.api.emit('9e8a4d2a-6f8c-415e-851b-bdfe4c01d5c1/service/rendered');
    },

    addButtons: function($share, mode) {
      $share.each($.proxy(function(index, share) {
        var position = this.positionSettings[$(share).data('sumome-share-pos')];
        var numShares = 'share' in this.settings ? abbrNum(this.settings['share']) : '0';

        if (
          position.total_shares_displayed
          && (
            this.settings.shares_label
            || this.settings.shares_minimum <= 0
            || !('share' in this.settings)
            || parseInt(this.settings['share']) >= this.settings.shares_minimum
          )
        ) {
          var el = $('<div class="sumome-share-client-animated sumome-share-client-share sumome-share-client-share-share sumome-share-client-count" data-sumome-share="share"></div>');

          if (position.total_shares_displayed && 'share' in this.settings && parseInt(this.settings['share']) >= this.settings.shares_minimum)
            el.append('<span><strong>' + numShares + '</strong><br>' + this.settings.shares_label + '</span>');
          else
            el.append('<span>' + this.settings.shares_label + '</span>');

          if (mode === 'mobile') {
            el.css('background', position.color ? position.color : 'transparent');
            el.css('color', (position.color ? Color.whiteOrBlack(position.color) : 'black'));
          } else {
            el.css('background', 'transparent');
            el.css('color', '#000');
          }
          $(share).append(el);
        }

        var servicesDisplayed = 0;
        var customData = '';

        if ($(share).data('sumome-share-url')) {
          customData += ' data-sumome-share-url="'
            + $(share).data('sumome-share-url') + '"';
        }

        if ($(share).data('sumome-share-text')) {
          customData += ' data-sumome-share-text="'
            + $(share).data('sumome-share-text') + '"';
        }

        position.services.forEach($.proxy(function(service) {
          if (servicesDisplayed < position.services_displayed || service === 'sumome') {
            if (service != 'share') {
              var el = $('<a' + customData + ' title="' + (this.settings.noSumoBranding && service == 'sumome' ? 'More' : $.shareServices[service].name) + '" class="sumome-share-client-animated sumome-share-client-share" data-sumome-share="' + service + '" href="javascript:void(0);"><img src="' + require('../../../images/apps/9e8a4d2a-6f8c-415e-851b-bdfe4c01d5c1/' + (this.settings.noSumoBranding && service == 'sumome' ? 'sumomepro' : service) + '-' + (position.color ? Color.whiteOrBlack(position.color) : 'white') + '-60.png') + '" alt="' + (this.settings.noSumoBranding && service === 'sumome' ? 'More' : $.shareServices[service].name) + '"></a>');
              if (
                position.shares_displayed
                && service in this.settings
                && parseInt(this.settings[service]) >= this.settings.shares_minimum
              ) {
                el.addClass('sumome-share-client-count');
                el.append('<span>' + (service in this.settings ? abbrNum(this.settings[service]) : '0') + '</span>');
              }
              el.css('background', position.color ? position.color : (('background' in $.shareServices[service]) ? $.shareServices[service].background : '#ccc'));
              el.css('color', position.color ? Color.whiteOrBlack(position.color) : ('color' in $.shareServices[service] ? $.shareServices[service].color : '#fff'));
              $(share).append(el);
              if (service != 'sumome')
                servicesDisplayed++;
            }
          }
        }, this));

        $('.sumome-share-client-share', $('[data-sumome-share-pos="' + $(share).data('sumome-share-pos') + '"]')).hover(
          $.proxy(function() {
            var service = $(this).data('sumome-share');
            if (service && service in $.shareServices) {
              var color = Color.shadeColor(position.color ? position.color : (('background' in $.shareServices[service]) ? $.shareServices[service].background : '#ccc'), -10);
              $(this).css('background', color);
            }
          }),
          $.proxy(function() {
            var service = $(this).data('sumome-share');
            if (service && service in $.shareServices) {
              $(this).css('background', position.color ? position.color : (('background' in $.shareServices[service]) ? $.shareServices[service].background : '#ccc'));
            }
          })
        );

        $('.sumome-share-client-share', share).on('click', $.proxy(function(e) {this.click(e);}, this));
      }, this));
    },

    bindCustomShares: function() {
      var $customShares = $('[data-sumome-share]:not(.sumome-share-client-share, [data-sumome-custom])');
      $customShares.on('click', $.proxy(function(e) {this.click(e);}, this)).attr('data-sumome-custom', true);
      if ($customShares.length > 0) {
        console.log("bound custom shares");
        this.updateCustomCounts();
      }

      var $inlineShares = $('[data-sumome-share-id]:empty');

      if ($inlineShares.length > 0) {
        // console.log('bound inline shares');

        var width = Math.min(window.screen.availWidth || $(window).width(),  $(window).width());
        var mode = width <= this.settings.mobile_width ? 'mobile' : 'desktop';

        $.each($inlineShares, $.proxy(function(inlineIndex, inlineShare) {
          var shareId = $(inlineShare).data('sumome-share-id')

          if (shareId in this.customPositions) {
            var customPosition = this.customPositions[shareId];

            if (mode != 'mobile' || (customPosition.show_mobile)) {
              var customPositionEl = $(inlineShare);
              var customData = '';

              if (customPositionEl.data('sumome-share-url')) {
                customData += ' data-sumome-share-url="'
                  + customPositionEl.data('sumome-share-url') + '"';
              }

              if (customPositionEl.data('sumome-share-text')) {
                customData += ' data-sumome-share-text="'
                  + customPositionEl.data('sumome-share-text') + '"';
              }

              customPositionEl.html(
                '<div class="sumome-share-client-wrapper sumome-share-client-wrapper-custom'
                + (customPosition.shares_displayed ? ' sumome-share-client-counts' : '')
                + ' sumome-share-client-' + this.settings.theme
                + (customPosition.float ? ' sumome-share-client-float-' + customPosition.float : '')
                + ' sumome-share-client-' + customPosition.size + '">'
                + '<div data-sumome-share-pos="' + customPosition.position_id + '"'
                + ' class="sumome-share-client sumome-share-client-custom'
                + (customPosition.shares_displayed ? ' sumome-share-client-counts' : '')
                + ' sumome-share-client-' + this.settings.theme
                + ' sumome-share-client-' + customPosition.size
                + ' sumome-share-client-' + customPosition.orientation
                + '"' + customData + '></div></div>'
              );

              this.positionSettings[customPosition.position_id] = customPosition;
            }
          }
        }, this));

        this.addButtons($('.sumome-share-client', $inlineShares), mode);
        this.applyPositionSettings();
        this.position();
        this.alignShareLabels();
        this.updateCustomCounts();
      }
    },

    updateCustomCounts: function() {
      $('[data-sumome-share-count]').each($.proxy(function(idx, el) {
        var service = $(el).data('sumome-share-count');
        if (/*this.settings.shares_displayed && */service in this.settings && parseInt(this.settings[service]) >= this.settings.shares_minimum) {
          $(el).text((service in this.settings ? abbrNum(this.settings[service]) : '0'));
        } else {
          $(el).text('');
        }
      }, this));
    },

    click: function(e) {
      var service = $(e.currentTarget).data('sumome-share');
      var targetUrl = $(e.currentTarget).data('sumome-share-url') || $(e.currentTarget).closest('.sumome-share-client').data('sumome-share-target-url') || getCurrentUri();
      var targetText = $(e.currentTarget).data('sumome-share-text') || $(e.currentTarget).closest('.sumome-share-client').data('sumome-share-target-text');

      if (service == 'sumome') {
        this.api.emit('event', { 'appId': '9e8a4d2a-6f8c-415e-851b-bdfe4c01d5c1', 'event': service + '-click', 'href': targetUrl });
        if (this.settings.current_mode === 'mobile')
          this.popupMobile(targetUrl, targetText);
        else
          this.popup(targetUrl, targetText);
      } else if (service != 'share') {
        this.api.emit('event', { 'appId': '9e8a4d2a-6f8c-415e-851b-bdfe4c01d5c1', 'event': service + '-click', 'href': targetUrl });

        if (service === 'twitter') {
          if (
            $('meta[name="twitter:title"]').length
            && 'undefined' === typeof $(e.currentTarget).data('sumome-share-text')
          ) {
            targetText = $('meta[name="twitter:title"]').eq(0).attr('content');
          }

          if (
            $('meta[name="twitter:url"]').length
            && 'undefined' === typeof $(e.currentTarget).data('sumome-share-url')
          ) {
            targetUrl = $('meta[name="twitter:url"]').eq(0).attr('content');
          }
        }

        var data = {
          url: targetUrl,
          text: targetText,
          siteId: this.api.properties.siteId,
          sumoUrl: this.api.properties.sumoUrl,
          shortenUrl: this.settings.use_shortener,
          shortener: this.settings.shortener + this.settings.short_domain,
          noSumoBranding: this.settings.noSumoBranding,
        };
        if ('services_settings' in this.settings && this.settings.services_settings && service in this.settings.services_settings) {
          $.extend(data, this.settings.services_settings[service]);
        }
        if (this.settings.noSumoBranding && 'url' in data && data.url && 'utm' in this.settings && this.settings.utm) {
          var uri = URI(data.url);
          if ('utm_source' in this.settings && this.settings.utm_source) {
            uri.removeQuery('utm_source');
            uri.addQuery('utm_source', this.settings.utm_source.replace('{service}', service));
          }

          if ('utm_medium' in this.settings && this.settings.utm_medium) {
            uri.removeQuery('utm_medium');
            uri.addQuery('utm_medium', this.settings.utm_medium.replace('{service}', service));
          }

          if ('utm_name' in this.settings && this.settings.utm_name) {
            uri.removeQuery('utm_campaign');
            uri.addQuery('utm_campaign', this.settings.utm_name.replace('{service}', service));
          }

          if ('utm_custom_key' in this.settings && this.settings.utm_custom_key) {
            if ('utm_custom_val' in this.settings && this.settings.utm_custom_val) {
              uri.removeQuery(this.settings.utm_custom_key);
              uri.addQuery(this.settings.utm_custom_key, this.settings.utm_custom_val.replace('{service}', service));
            }
          }

          data.url = uri.toString();
        }

        $.share(service, data, $.proxy(function(service) {this.fetch([service]);}, this));
        //setTimeout($.proxy(function() {this.fetch([service]);}, this), 1000 * 30);
      }
    },

    applyPositionSettings: function applyPositionSettings() {
      // console.log('applying position settings...');

      var settings = this.settings;

      if (typeof settings !== 'object') {
        return;
      }

      if (
        (!Array.isArray(settings.positions) || settings.positions.length === 0)
        && typeof this.customPositions !== 'object'
      ) {
        return;
      }

      if (typeof settings.position_settings !== 'object') {
        return;
      }

      var positions = {
        lp: { suffix: 'left-page', layout: 'vertical' },
        rp: { suffix: 'right-page', layout: 'vertical' },
        la: { suffix: 'left-sidebar-article', layout: 'vertical' },
        ra: { suffix: 'right-sidebar-article', layout: 'vertical' },
        hla: { suffix: 'header-left-article', layout: 'horizontal' },
        hca: { suffix: 'header-center-article', layout: 'horizontal' },
        hra: { suffix: 'header-right-article', layout: 'horizontal' },
        tla: { suffix: 'top-left-article', layout: 'horizontal' },
        tca: { suffix: 'top-center-article', layout: 'horizontal' },
        tra: { suffix: 'top-right-article', layout: 'horizontal' },
        bla: { suffix: 'bottom-left-article', layout: 'horizontal' },
        bca: { suffix: 'bottom-center-article', layout: 'horizontal' },
        bra: { suffix: 'bottom-right-article', layout: 'horizontal' },
        dbb: { suffix: 'wrapper-desktop-bottom-bar', layout: 'horizontal' },
        mbt: { suffix: 'wrapper-mobile-top-bar', layout: 'horizontal' },
        mbb: { suffix: 'wrapper-mobile-bottom-bar', layout: 'horizontal' },
        mbl: { suffix: 'open-mobile-left', layout: 'horizontal' },
        mbr: { suffix: 'open-mobile-right', layout: 'horizontal' },
      };

      // Injects the the custom positions to be styled
      if ($(this.customPositions).length) {
        $.each(
          this.customPositions,
          $.proxy(function customPositionProxy(positionIndex, customPosition) {
            settings.positions.push(customPosition.position_id);
            positions[customPosition.position_id] = {
              suffix: false,
              layout: customPosition.orientation
            };
          }, this)
        );
      }

      settings.positions.forEach($.proxy(function positionProxy(position) {
        if (!positions.hasOwnProperty(position)) {
          return;
        }

        var settings = this.positionSettings[position];
        var positionData = positions[position];
        var target;

        if (positionData.suffix) {
          target = $('.sumome-share-client-' + positionData.suffix);
        } else {
          if (typeof settings === 'undefined') {
            return;
          }

          target = $('[data-sumome-share-id="' + settings.position_id + '"]');
        }

        target
          .removeClass('sumome-share-client-circle')
          .removeClass('sumome-share-client-rounded');

        if (settings.button_style && settings.button_style !== 'square') {
          target.addClass('sumome-share-client-' + settings.button_style);
        }

        if (settings.button_padding && settings.button_padding > 0) {
          $('.sumome-share-client-share', target).css(
            'margin' + (positionData.layout == 'vertical' ? 'Bottom' : 'Right'),
            settings.button_padding + 'px'
          );
        }

        if (settings.shares_background) {
          if (['mbl','mbr'].indexOf(position) > -1) {
            var color = Color.whiteOrBlack(settings.shares_background);

            target
              .css({backgroundColor: Color.hexToRGBA(
                settings.shares_background,
                0.8
              )})
              .find('span').css({ color: color });

            if (color === 'white') {
              target.find('img')
                .attr(
                  'src',
                  require('../../../images/apps/9e8a4d2a-6f8c-415e-851b-bdfe4c01d5c1/share-white-60.png')
                );
            }
          } else {
            if (settings.shares_background) {
              var properties = {
                backgroundColor: settings.shares_background,
                color: Color.whiteOrBlack(settings.shares_background),
              };
            } else {
              var properties = {
                backgroundColor: 'transparent',
                color: '#000',
              };
            }

            $('.sumome-share-client-share-share', target).css(properties);
          }
        }

        // Grabs the parent wrapper for side of article
        if (['la','ra'].indexOf(position) > -1) {
          target = target.closest('.sumome-share-client-wrapper');
        }

        // Skip page positions, they are handled in this.position()
        if (['lp','rp'].indexOf(position) < 0) {
          return;
        }

        if (['mbt','mbb','mbl','mbr'].indexOf(position) > -1) {
          if (settings.offset_x && settings.offset_x !== 0) {
            var sideProperty = 'left';
            var sideValue = settings.offset_x;

            if (position == 'mbr') {
              sideProperty = 'right';
              sideValue = 0 - sideValue;
            }

            target.css(sideProperty, sideValue + 'px');
          }

          // Don't set offset Y for mobile bars since styleBuffer handles it
          if (
            ['mbt','mbb'].indexOf(position) < 0
            && settings.offset_y
            && settings.offset_y !== 0
          ) {
            target.css('bottom', (0 - settings.offset_y) + 'px');
          }
        } else {
          var topProperty = 'marginTop';
          var sideProperty = 'marginLeft';
          var sideValue = 0;

          if (settings.position_id) {
            target = $('.sumome-share-client-wrapper-custom', target);
          }

          if (settings.offset_x && settings.offset_x !== 0) {
            if (position === 'la') {
              sideProperty = 'left';
            } else if (position === 'ra') {
              sideProperty = 'right';
            } else if (['tra','hra','bra'].indexOf(position) > -1) {
              sideProperty = 'marginRight';
            }

            if (['ra','tra','hra','bra'].indexOf(position) > -1) {
              sideValue = 0 - settings.offset_x;
            } else {
              sideValue = settings.offset_x;
            }

            target.css(sideProperty, sideValue + 'px');
          }

          if (settings.offset_y && settings.offset_y !== 0) {
            if (['la','ra'].indexOf(position) > -1) {
              topProperty = 'top';
            }

            target.css(topProperty, settings.offset_y + 'px');
          }
        }
      }, this));
    },

    alignShareLabels: function() {
      // console.log('aligning share labels...');
      $.each($('.sumome-share-client-share-share'), function() {
        var buttonHeight = $(this).outerHeight();
        var span = $(this).find('span').css('bottom', 'auto');
        var spanHeight = $(span).outerHeight();
        $(span).css('top', ((buttonHeight - spanHeight) / 2) + 'px');
      });
    },

    scroll: function() {
      if(this.$mobileBottomBar != null){
        var scrollTop = $(window).scrollTop();
        var hideClass = 'sumome-share-client-wrapper-mobile-bottom-bar-hidden';
        var isVisible = !(this.$mobileBottomBar.hasClass(hideClass));
        var barHeight = this.$mobileBottomBar.height() || 16;
        if (scrollTop > this.lastScrollTop){
          // console.log('SCROLLED DOWN');
          this.lastScrollUp = 0;
          if(!isVisible){
            this.$mobileBottomBar.css('bottom', '');
            this.$mobileBottomBar.removeClass(hideClass);
          }
        } else if(scrollTop < this.lastScrollTop) {
          // console.log('SCROLLED UP');
          this.lastScrollUp += this.lastScrollTop - scrollTop;
          if((isVisible && this.lastScrollUp >= barHeight/2) || scrollTop == 0){
            this.$mobileBottomBar.css('bottom', barHeight*(-1));
            this.$mobileBottomBar.addClass(hideClass);
          }
        }
        // console.log('Scrolled UP: ' + this.lastScrollUp + 'px;');
        this.lastScrollTop = scrollTop;
      }
    },
  };

  return share;
});
